var _defs, _path, _path2, _path3, _ellipse, _g, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBerkley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "logo-berkley-white",
    width: 140.39,
    height: 41.63,
    viewBox: "0 0 140.39 41.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:#487b41}.cls-2{fill-rule:evenodd}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_273",
    d: "M95.629 11.57h2.452v15.218c.973-.945 7.338-7.066 7.338-7.066l3.36.009s-4.8 4.623-7.151 6.879c2.649 3.22 7.983 9.715 7.983 9.715l-3.266-.019L100 28.192l-1.9 1.834-.009 6.252H95.62c.009.001.009-16.444.009-24.708z",
    className: "cls-1",
    "data-name": "Trazado 273",
    transform: "translate(-6.126 -3.1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_274",
    d: "M136.662 45.12l3.753-8.882-6.205-15.92h2.929l4.446 12.982 4.876-13.009h2.527s-1.292 3.416-1.928 5.073c-2.415 6.289-7.553 19.748-7.553 19.748h-2.845z",
    className: "cls-1",
    "data-name": "Trazado 274",
    transform: "translate(-8.599 -3.659)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_275",
    d: "M112.238 11.57h2.5v20.881a5.8 5.8 0 0 0 .1 1.273c.056.243.281.646.449.646 1.048.028.852.758.852 1.385 0 .281-.028.552-.047.814-2.078.309-3.435-.636-3.762-2.583a8.3 8.3 0 0 1-.112-1.357q-.014-10.178 0-20.356a4.588 4.588 0 0 1 .02-.703z",
    className: "cls-1",
    "data-name": "Trazado 275",
    transform: "translate(-7.189 -3.1)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_6",
    cx: 0.122,
    cy: 20.815,
    className: "cls-1",
    "data-name": "Elipse 6",
    rx: 0.122,
    ry: 20.815,
    transform: "translate(33.188)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_128",
    "data-name": "Grupo 128",
    transform: "translate(0 .159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_276",
    d: "M24.8 23.365a12.423 12.423 0 0 1-12.371 12.429v-4.025a8.381 8.381 0 0 0 0-16.763v-4.024A12.388 12.388 0 0 1 24.8 23.365zM12.429 35.794v-4.025a8.381 8.381 0 1 1 0-16.763v-4.024a12.455 12.455 0 0 0-8.4 3.248V2.69H0v20.684a12.432 12.432 0 0 0 12.429 12.42z",
    className: "cls-2",
    "data-name": "Trazado 276",
    transform: "translate(0 -2.69)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_127",
    "data-name": "Grupo 127",
    transform: "translate(5.943 16.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_277",
    d: "M19.434 20.45c-1.806 0-6.542 3.772-6.542 3.772S8.905 20.45 6.35 20.45c.693 1.039 1.039 1.189 1.039 3.922 0 1.385-.1 4.567 2.377 5.007a4.812 4.812 0 0 0 .842.047h.992a1.3 1.3 0 0 1 .543.047.948.948 0 0 1 .449.2.9.9 0 0 1 .3.3c.047-.1.2-.2.3-.3a.864.864 0 0 1 .449-.2 1.639 1.639 0 0 1 .543-.047h.992a3.225 3.225 0 0 0 .693-.047h.15c2.48-.449 2.377-3.622 2.377-5.007.004-2.733.346-2.883 1.038-3.922zM11.6 28.19a2.3 2.3 0 0 1-.889.15h-.1c-1.385 0-1.984-1.142-1.984-2.583 0-1.189.243-2.976-.2-3.772a1.582 1.582 0 0 1 1.591 1.488c0 .346-.047 1.441-.047 2.377 0 .739.346.945.646.992h.2c.346 0 .693-.243.693-.889 0-.6-.346-.945-.889-.693-.047.047-.2.1-.3.2a2.128 2.128 0 0 1 .3-1.189 1.054 1.054 0 0 1 .992-.346 1.154 1.154 0 0 1 .992.739 3.1 3.1 0 0 1 .2 1.488 2.215 2.215 0 0 1-.2.992A1.926 1.926 0 0 1 11.6 28.19zm-1.142-2.181a.277.277 0 0 1 .15-.253h.1a.256.256 0 1 1 0 .505h-.1a.287.287 0 0 1-.149-.252zm2.724 2.976a1.23 1.23 0 0 1-.3.449 2.228 2.228 0 0 1-.3-.449 2.367 2.367 0 0 1-.2-.6.945.945 0 0 1 .2-.543 3.462 3.462 0 0 1 .3-.243 1.369 1.369 0 0 1 .3.243.914.914 0 0 1 .243.543 1.468 1.468 0 0 1-.243.601zm3.968-3.229a2.406 2.406 0 0 1-1.292 2.48 3.078 3.078 0 0 1-.693.1h-.045a2.47 2.47 0 0 1-.945-.15 2.026 2.026 0 0 1-.992-1.039 3.862 3.862 0 0 1 0-2.48 1.211 1.211 0 0 1 .992-.739 1.054 1.054 0 0 1 .992.346 1.818 1.818 0 0 1 .3 1.189.916.916 0 0 0-.3-.2c-.5-.253-.842.1-.842.693 0 .646.3.889.693.889h.15c.3-.047.646-.243.646-.992v-2.371a.671.671 0 0 1 .047-.3 1.507 1.507 0 0 1 1.488-1.189c-.395.787-.198 2.575-.198 3.764zm-1.834.253a.277.277 0 0 1-.15.253h-.1a.256.256 0 1 1 0-.505h.1a.267.267 0 0 1 .15.252z",
    className: "cls-2",
    "data-name": "Trazado 277",
    transform: "translate(-6.35 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_278",
    d: "M13.105 23.379l3.734-2.929H9.38z",
    className: "cls-2",
    "data-name": "Trazado 278",
    transform: "translate(-6.544 -20.45)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_279",
    d: "M58.7 23.2s2.733-.88 2.733-5.382-3.893-6.383-6.945-6.383H45.77v24.929h9.313c3.491 0 7.225-1.965 7.225-6.982S58.7 23.2 58.7 23.2zm-10.356-9.308h6.7a3.536 3.536 0 0 1 3.734 3.65c0 1.123.281 4.736-3.7 4.736h-6.734zm6.7 20.188h-6.7v-9.434h6.823c2.246 0 4.333 1.207 4.333 4.09s-.8 5.344-4.455 5.344z",
    className: "cls-1",
    "data-name": "Trazado 279",
    transform: "translate(-2.932 -3.092)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_280",
    d: "M79.225 26.831c0-2.031-.459-7-6.149-7s-7.066 3.809-7.066 9.022c0 6.757 3.538 8.451 6.935 8.451a12.646 12.646 0 0 0 5.5-1.114V33.9a12.93 12.93 0 0 1-5.5 1.048c-3.472 0-4.455-2.639-4.455-5.054h10.735zm-2.49.655h-8.18s-.555-5.241 4.063-5.241c5.1.009 4.118 5.241 4.118 5.241z",
    className: "cls-1",
    "data-name": "Trazado 280",
    transform: "translate(-4.229 -3.629)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    d: "M132.365 26.831c0-2.031-.459-7-6.149-7s-7.066 3.809-7.066 9.022c0 6.757 3.538 8.451 6.935 8.451a12.7 12.7 0 0 0 5.5-1.114V33.9a12.93 12.93 0 0 1-5.5 1.048c-3.472 0-4.455-2.639-4.455-5.054h10.735zm-2.49.655H121.7s-.552-5.241 4.062-5.241c5.096.009 4.114 5.241 4.114 5.241z",
    className: "cls-1",
    "data-name": "Trazado 281",
    transform: "translate(-7.634 -3.629)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    d: "M83.3 20.058h1.582l.44 1.366a8.3 8.3 0 0 1 4.9-1.694c2.125 0 2.293.328 2.293.328v2.564a4.832 4.832 0 0 0-2.4-.543 7.837 7.837 0 0 0-4.146 1.039V36.8H83.3z",
    className: "cls-1",
    "data-name": "Trazado 282",
    transform: "translate(-5.337 -3.623)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBerkley);
export default __webpack_public_path__ + "static/media/logo-berkley.7d1e50c4445abb25c1af69fb6a88717a.svg";
export { ForwardRef as ReactComponent };